import {useMutation, UseMutationResult, useQuery, useQueryClient, UseQueryResult} from '@tanstack/react-query';
import {fundRepresentativesApi} from '../api';
import {EditFundRepresentativeParams, FundRepresentativeModel} from '../model';

type FundRepresentativeByIdState = {
  getFundRepresentative: UseQueryResult<FundRepresentativeModel, Error>;
  updateMutation: UseMutationResult<FundRepresentativeModel, Error, EditFundRepresentativeParams>;
  refetch: () => void;
};

export const useFundRepresentativeById = (id: string): FundRepresentativeByIdState => {
  const queryClient = useQueryClient();

  const getFundRepresentative = useQuery<FundRepresentativeModel, Error>({
    queryKey: ['fund-representative', id],
    queryFn: () => fundRepresentativesApi.getById(id),
    enabled: !!id,
  });

  const refetch = () => {
    queryClient.invalidateQueries({queryKey: ['fund-representative', id]});
  };

  const updateMutation = useMutation<FundRepresentativeModel, Error, EditFundRepresentativeParams>({
    mutationFn: ({displayName}) => fundRepresentativesApi.update({representativeId: id, displayName}),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['fund-representative', id]});
    },
  });

  return {
    getFundRepresentative,
    updateMutation,
    refetch,
  };
};
